import {
  AccountCircle as AccountCircleIcon,
  ArrowForwardIos as ArrowForwardIosIcon,
  Group as GroupIcon,
} from "@mui/icons-material";
import { Box, Menu, MenuItem } from "@mui/material";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  getUserOrg,
  getUserName,
  isOrgUser,
  setSandbox,
  setUser,
} from "../../../utils/io";
import theme from "../../../utils/theme";
import NavLink from "./NavLink";

export default function NavFooter() {
  const history = useHistory();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleExpandDrop = (e) => setAnchorEl(e.currentTarget);
  const handleCloseDrop = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          padding: "12.4px 12px",
          margin: "0 8px",
          borderRadius: "4px",
          color: theme.colors.darkGrey,
          textDecoration: "none",
          position: "relative",
          cursor: "pointer",
          "&:hover": {
            background: theme.colors.lighterBlue,
            color: theme.colors.blue,
            "& > svg": {
              color: theme.colors.blue,
            },
          },
        }}
        onClick={handleExpandDrop}
        aria-hidden="true"
      >
        <AccountCircleIcon
          sx={{
            mr: "8px",
            color: theme.colors.darkGrey,
            fontSize: theme.fontSize.large,
            marginLeft: "2.5px",
          }}
        />
        <Box
          sx={{
            fontSize: theme.fontSize.medium,
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
            height: 16.01,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <span>{getUserName()}</span>
          <ArrowForwardIosIcon
            sx={{
              fontSize: theme.fontSize.small,
              marginLeft: "10px",
            }}
            onClick={handleExpandDrop}
          />
        </Box>
      </Box>

      <Menu
        open={!!anchorEl}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        onClose={handleCloseDrop}
      >
        {[
          {
            title: "Change Password",
            handler: () => history.push("/change-password"),
          },
          {
            title: "Logout",
            handler: () => {
              setUser({});
              setSandbox(false);
              window.location.reload();
            },
          },
        ].map((item) => (
          <MenuItem
            onClick={item.handler}
            key={item.title}
            sx={{
              "&:hover ": {
                color: theme.colors.blue,
              },
            }}
          >
            {item.title}
          </MenuItem>
        ))}
      </Menu>

      <NavLink
        path="/organization"
        title={getUserOrg()}
        icon={GroupIcon}
        isShown={isOrgUser}
      />
    </Box>
  );
}
